import useMediaQuery from '@material-ui/core/useMediaQuery';
import {useTheme} from "@material-ui/core/styles";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Table, TableBody, TableCell,
    TableContainer, TableRow, TextareaAutosize, TextField, Typography, withStyles
} from "@material-ui/core";
import React, {useEffect, useRef} from "react";
import UsersManager from "../managers/UsersManager";
import Routes from "../constants/Routes";
import AppColors from "../colors/AppColors";
import CryptoUtils from "../utils/CryptoUtils";
import ClientSeedTextField from "../views/ClientSeedTextField";
import {grey} from "@material-ui/core/colors";

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
        width: 150
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

export default function ProvablyFairDialog(props: any) {

    let gameType = props.gameType ?? -1;
    let open = props.open;
    const onDialogClosed = props.onDialogClosed;
    const [openDialog, setOpenDialog] = React.useState(open);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const loggedInUser = UsersManager.getLoggedInUser() ? JSON.parse(UsersManager.getLoggedInUser() as string) : {};
    const howToRef = useRef(null);
    const fieldsWidth = '80%';
    const textareaWidth = '92%';

    const handleDialogClose = () => {
        setOpenDialog(false);
        onDialogClosed();
    };

    useEffect(() => {
        setOpenDialog(open);
    }, [open]);

    const previousGamesAvailable = () => {
        return loggedInUser["previousServerSeed"] !== "";
    }

    const CurrentSeedsContainer = React.forwardRef(function (props: any, ref: any) {
        return <TableContainer style={{
            backgroundColor: AppColors.lightenOrDarken('#c9e9f6', 50)
        }}>
            <Table>
                <TableBody>
                    <StyledTableRow>
                        <StyledTableCell>
                            <Typography align={"center"} dangerouslySetInnerHTML={{
                                __html: ` <b>Server Seed Hash
                                    <br/>(SHA 512)</b>`
                            }}/>
                        </StyledTableCell>
                        <StyledTableCell>
                            <TextareaAutosize
                                contentEditable={false}
                                value={loggedInUser["activeServerSeedHash"]}
                                style={{
                                    fontStyle: 'bold',
                                    fontWeight: 600,
                                    width: textareaWidth,
                                    background: grey[100]
                                }}/>
                        </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <StyledTableCell>
                            <Typography align={"center"} dangerouslySetInnerHTML={{__html: `<b>Client Seed</b>`}}/>
                        </StyledTableCell>
                        <StyledTableCell>
                            <ClientSeedTextField/>
                        </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <StyledTableCell>
                            <Typography align={"center"} dangerouslySetInnerHTML={{__html: `<b>Nonce</b>`}}/>
                        </StyledTableCell>
                        <StyledTableCell>
                            <TextField value={loggedInUser["activeNonce"]}
                                       variant={"outlined"}
                                       size={"small"}
                                       style={{
                                           fontStyle: 'bold',
                                           fontWeight: 600
                                       }}/>
                        </StyledTableCell>
                    </StyledTableRow>
                </TableBody>
            </Table>
        </TableContainer>
    });

    const PreviousSeedsContainer = React.forwardRef(function (props: any, ref: any) {
        return <TableContainer style={{
            backgroundColor: AppColors.lightenOrDarken('#c9e9f6', 50)
        }}>
            <Table>
                <TableBody>
                    <StyledTableRow>
                        <StyledTableCell>
                            <Typography align={"center"} dangerouslySetInnerHTML={{
                                __html: ` <b>Previous Server Seed Hash
                                    <br/>(SHA 512)</b>`
                            }}/>
                        </StyledTableCell>
                        <StyledTableCell>
                            <TextareaAutosize
                                contentEditable={false}
                                value={CryptoUtils.SHA512Digest(loggedInUser["previousServerSeed"])} style={{
                                fontStyle: 'bold',
                                fontWeight: 600,
                                width: textareaWidth,
                                background: grey[100]
                            }}/>
                        </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <StyledTableCell>
                            <Typography align={"center"} dangerouslySetInnerHTML={{
                                __html: ` <b>Previous Server Seed</b>`
                            }}/>
                        </StyledTableCell>
                        <StyledTableCell>
                            <TextareaAutosize
                                contentEditable={false}
                                value={loggedInUser["previousServerSeed"]} style={{
                                fontStyle: 'bold',
                                fontWeight: 600,
                                width: textareaWidth,
                                background: grey[100]
                            }}/>
                        </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <StyledTableCell>
                            <Typography align={"center"}
                                        dangerouslySetInnerHTML={{__html: `<b>Previous Client Seed</b>`}}/>
                        </StyledTableCell>
                        <StyledTableCell>
                            <TextField value={loggedInUser["previousClientSeed"]}
                                       size={"small"}
                                       variant={"outlined"}
                                       style={{
                                           fontStyle: 'bold',
                                           fontWeight: 600,
                                       }}/>
                        </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <StyledTableCell>
                            <Typography align={"center"} dangerouslySetInnerHTML={{__html: `<b>Previous Nonce</b>`}}/>
                        </StyledTableCell>
                        <StyledTableCell>
                            <TextField value={loggedInUser["previousNonce"]}
                                       variant={"outlined"}
                                       size={"small"}
                                       style={{
                                           fontStyle: 'bold',
                                           fontWeight: 600,

                                       }}/>
                        </StyledTableCell>
                    </StyledTableRow>
                </TableBody>
            </Table>
        </TableContainer>
    });

    const moreParams = () => {
        // noinspection DuplicatedCode
        let result = "";
        if (loggedInUser) {
            let previousServerSeed = loggedInUser["previousServerSeed"];
            let previousClientSeed = loggedInUser["previousClientSeed"];
            let previousNonce = loggedInUser["previousNonce"];
            if (previousServerSeed) {
                result = "?server_seed=" + previousServerSeed + "&server_seed_hash=" + CryptoUtils.SHA512Digest(previousServerSeed) + "&client_seed=" + previousClientSeed + "&nonce=" + previousNonce + "&gametype=" + gameType;
            }
        }
        return result;
    }

    const navigateOut = () => {
        window.location.href = Routes.VERIFY_RESULTS + "/" + moreParams();
    }

    return (
        <Dialog
            disableBackdropClick={true}
            fullScreen={fullScreen}
            open={openDialog}
            onClose={() => handleDialogClose()}
            aria-labelledby="responsive-dialog-title">
            <DialogTitle style={{
                textAlign: 'center',
                fontWeight: 600,
                fontStyle: 'bold'
            }} id="responsive-dialog-title">{"Seeds For Your Next Game/Roll"}</DialogTitle>
            <DialogContent>
                <CurrentSeedsContainer/>
                <DialogTitle style={{
                    textAlign: 'center',
                    fontWeight: 600,
                    fontStyle: 'bold'
                }} id="responsive-dialog-title-previous">{"Previous Game/Roll Details"}</DialogTitle>

                {
                    UsersManager.hasRolled() &&
                    <PreviousSeedsContainer/>
                }
                {
                    !UsersManager.hasRolled() &&
                    <Typography
                        align={"center"}
                        style={{
                            fontWeight: 400
                        }}>
                        You haven't rolled or played yet since reloading the page.
                    </Typography>
                }
                <Button
                    onClick={navigateOut}
                    style={{
                        color: AppColors.BLUE,
                        fontWeight: 600,
                        fontSize: 14,
                        marginTop: 15,
                        textAlign: 'center',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        display: 'block',
                        textDecoration: 'none'
                    }}>CLICK HERE TO VERIFY YOUR GAMES/ROLLS
                </Button>
                <Typography
                    ref={howToRef}
                    align={'center'}
                    style={{
                        paddingTop: 10,
                        lineHeight: 1.8
                    }}
                    dangerouslySetInnerHTML={{
                        __html: `This game is provably fair. What that means is that there is no way the site can cheat you by picking a number/numbers that is in our favour.

The way this works is that each roll or winning numbers are calculated using 3 parameters - <b>the server seed, client seed</b> and <b>nonce</b>. Out of these, we show you the client seed and nonce that will be used for your next roll/winning numbers along with a <b>SHA512</b> hash of the server seed. You can also change the client seed if you wish. The server seed is the only part that is kept a secret until after the roll/numbers draw.

Then after you roll/play, under the section titled <b>PREVIOUS GAME/ROLL DETAILS</b>, we show you the server seed that was used and you can verify that this was the same server seed that we said we were going to use before the roll by checking if the <b>SHA512</b> hash of this seed matches the <b>SHA512</b> hash that we showed you before the roll/numbers draw.To know exactly how we calculate the rolls/winning numbers, read the section below titled <b>How are rolls/winning numbers calculated</b>?

After you roll/play, you can also click the link above named <b>CLICK HERE TO VERIFY YOUR GAMES/ROLLS</b> to verify your rolls/winning numbers using our javascript based roll/game verifier which uses the same seeds to re-calculate the roll/winning numbers right in your browser without any external communication.`
                    }}/>
                <Typography
                    align={"center"}
                    style={{
                        marginTop: 30,
                        marginBottom: 30,
                    }}
                    dangerouslySetInnerHTML={{__html: `<b>How are rolls/winning numbers calculated?</b>`}}/>
                <Typography dangerouslySetInnerHTML={{
                    __html: `<ul>
    <li>
    - <b>For The FREE BTC</b><br/><br/>
    <ol>
        <li>
            Two strings are created :
            STRING1 = "[NONCE]:[SERVER SEED]:[NONCE]"
            STRING2 = "[NONCE]:[CLIENT SEED]:[NONCE]"
        </li><br/>
        <li>
            Then HMAC-SHA512 is used to hash STRING1 with STRING2 as the secret key, giving us a 128 character hex string.
        </li><br/>
        <li>
            The first 8 characters of the hex string are taken and converted to a decimal.
        </li><br/>
        <li>
            This decimal is then divided by 429496.7295 and rounded off to the nearest whole number.
        </li><br/>
        <li>
            This whole number is used as your roll, with the maximum possible value being 10,000.
        </li>
    </ol>
</li>
<br/>
<br/>
<li>
    - <b>For The 6/49 GAME</b><br/><br/>
    <ol>
        <li>
            Two strings are created :
            STRING1 = "[NONCE]:[SERVER SEED]:[NONCE]"
            STRING2 = "[NONCE]:[CLIENT SEED]:[NONCE]"
        </li><br/>
        <li>
            Then HMAC-SHA512 is used to hash STRING1 with STRING2 as the secret key, giving us a 128 character hex string.
        </li><br/>
        <li>
            The first 64 characters of the hex string are taken and converted to a Big Integer.
        </li><br/>
        <li>
            The Big Integer is continuously divided by the number 50 up to 6 times to bring out all the remainders without repetition that make it up.
        </li>
        <br/>
        <li>
            If zero is encountered as the remainder, 1 is added to it to make it 0+1 = 1.
        </li> 
        <br/>       
        <li>
            The resulting 6 numbers are used as your winning numbers
        </li>
    </ol>
</li>

</ul>
    `
                }}/>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleDialogClose} color="primary">
                    CLOSE
                </Button>
            </DialogActions>
        </Dialog>);
}